module.exports = __webpack_public_path__ + "img/img1.3a60e8c4.jpg";